import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFloorMutationVariables = Types.Exact<{
  input: Types.Floors_Insert_Input;
}>;


export type CreateFloorMutation = { __typename?: 'mutation_root', insert_floors_one?: { __typename?: 'floors', id: any, name: string, building_id: any } | null };


export const CreateFloorDocument = gql`
    mutation createFloor($input: floors_insert_input!) {
  insert_floors_one(object: $input) {
    id
    name
    building_id
  }
}
    `;
export type CreateFloorMutationFn = Apollo.MutationFunction<CreateFloorMutation, CreateFloorMutationVariables>;

/**
 * __useCreateFloorMutation__
 *
 * To run a mutation, you first call `useCreateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorMutation, { data, loading, error }] = useCreateFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFloorMutation(baseOptions?: Apollo.MutationHookOptions<CreateFloorMutation, CreateFloorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFloorMutation, CreateFloorMutationVariables>(CreateFloorDocument, options);
      }
export type CreateFloorMutationHookResult = ReturnType<typeof useCreateFloorMutation>;
export type CreateFloorMutationResult = Apollo.MutationResult<CreateFloorMutation>;
export type CreateFloorMutationOptions = Apollo.BaseMutationOptions<CreateFloorMutation, CreateFloorMutationVariables>;